import { render, staticRenderFns } from "./Position.vue?vue&type=template&id=1b594768&scoped=true&"
import script from "./Position.vue?vue&type=script&lang=js&"
export * from "./Position.vue?vue&type=script&lang=js&"
import style0 from "./Position.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Position.vue?vue&type=style&index=1&id=1b594768&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b594768",
  null
  
)

export default component.exports